import type { RouteRecordRaw } from 'vue-router';

export const inventoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/inventory',
    name: 'inventory',
    redirect: '/inventory/list',
    component: () => import('pages/trade/admin/inventory/McInventory.vue'),
    meta: {
      title: 'Inventories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'inventoryList',
        component: () => import('pages/trade/admin/inventory/InventoryList.vue'),
        meta: {
          title: 'Inventories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail',
        name: 'inventoryDetail',
        component: () => import('pages/trade/admin/inventory/InventoryDetail.vue'),
        meta: {
          title: 'Inventory Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'inventoryNew',
        component: () => import('pages/trade/admin/inventory/InventoryNew.vue'),
        meta: {
          title: 'New Inventory',
          requiresAuth: true,
        },
      },
      {
        path: 'view',
        name: 'inventoryView',
        component: () => import('pages/trade/admin/inventory/InventoryView.vue'),
        meta: {
          title: 'Inventory Details (View only)',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'inventoryExplorer',
        component: () => import('pages/trade/admin/inventory/InventoryExplorer.vue'),
        meta: {
          title: 'Product-Inventories Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'move',
        name: 'inventoryMove',
        component: () => import('pages/trade/admin/inventory/MoveInventory.vue'),
        meta: {
          title: 'Move Inventory Item(s) - In & Out',
          requiresAuth: true,
        },
      },
      {
        path: 'miss',
        name: 'inventoryMiss',
        component: () => import('pages/trade/admin/inventory/MissingInventory.vue'),
        meta: {
          title: 'Missing Inventory Item(s)',
          requiresAuth: true,
        },
      },
      {
        path: 'exchange',
        name: 'inventoryExchange',
        component: () => import('pages/trade/admin/inventory/ExchangeInventory.vue'),
        meta: {
          title: 'Exchange Inventory Item(s) - In & Out',
          requiresAuth: true,
        },
      },
      {
        path: 'return',
        name: 'inventoryReturn',
        component: () => import('pages/trade/admin/inventory/ReturnInventory.vue'),
        meta: {
          title: 'Return Inventory Item(s) - In & Out',
          requiresAuth: true,
        },
      },
    ],
  },
];
